import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import consumeRequest from './consume.repository';

type InitialState = {
  loading: boolean;
  data?: boolean;
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const consume = createAsyncThunk(
  'consume',
  async (tempId: string) => {
    await consumeRequest(tempId);
    return true;
  }
);

const consumeSlice = createSlice({
  name: 'consume',
  initialState,
  reducers: {
    consumeReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(consume.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      consume.fulfilled,
      (state, action: PayloadAction<boolean>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(consume.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default consumeSlice.reducer;
export const { consumeReset } = consumeSlice.actions;
